import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Icon,
  Tooltip,
} from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import AlertDialog from './components/AlertDialog';

import Contact from './components/Contact';
import BloodCalendar from './components/BloodCalendar';
import InfusionCalendar from './components/InfusionCalendar';
import MoreInformation from './components/MoreInformation';

import { Container } from './styles';

const options = [
  {
    icon: <Icon className="icon-add-drug" />,
    label: 'Reg. de medicamento',
  },
  {
    icon: <Icon className="icon-blood-calendar" />,
    label: 'Controle de sangramento',
  },
  {
    icon: <Icon className="icon-drug-calendar" />,
    label: 'Diário de infusão',
  },
  {
    icon: <CallOutlinedIcon />,
    label: 'Contato',
  },
  { icon: <Icon className="icon-user-add" />, label: 'Mais informações' },
];

function DataTable({ data }) {
  const [modalVisible, setModalVisible] = useState(true);
  const [active, setActive] = useState(null);

  const history = useHistory();

  useEffect(() => {
    if (!active) return;

    setModalVisible(true);
  }, [active]);

  function renderSwitch() {
    const { tab, user } = active;

    switch (tab.index) {
      case 0:
        return history.push({
          pathname: '/drug',
          state: { user },
        });

      case 1:
        return <BloodCalendar user={user} />;

      case 2:
        return <InfusionCalendar user={user} />;

      case 3:
        return <Contact user={user} />;

      case 4:
        return <MoreInformation user={user} />;

      default:
        return <Contact user={user} />;
    }
  }

  return (
    <Container>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome completo</TableCell>
              <TableCell align="center">Hemocentro</TableCell>
              <TableCell align="center">Registrado em</TableCell>
              <TableCell align="center">Dados</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row) => {
              const parsedDate = format(parseISO(row.created_at), 'dd/MM/yyyy');

              return (
                <TableRow key={row.name}>
                  <TableCell id="name">
                    <div>{row.name}</div>
                  </TableCell>

                  <TableCell align="center">
                    {row.hemocenter && row.hemocenter.alias}
                  </TableCell>

                  <TableCell id="date" align="center">
                    {parsedDate}
                  </TableCell>

                  <TableCell align="center">
                    {options.map((i, index) => (
                      <Tooltip title={i.label} key={i.label}>
                        <IconButton
                          onClick={() =>
                            setActive({
                              tab: { title: i.label, index },
                              user: { ...row },
                            })
                          }
                        >
                          {i.icon}
                        </IconButton>
                      </Tooltip>
                    ))}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {active && (
        <AlertDialog
          title={active.tab.title}
          open={modalVisible}
          setOpen={setModalVisible}
        >
          {renderSwitch()}
        </AlertDialog>
      )}
    </Container>
  );
}

DataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DataTable;
